import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import { useData } from "../../context/DataProvider";
import { formatDate } from "../../utils/commonText";
import { richTextRenderer } from "../../utils/commonUtil";
import styles from "./IzmiriBG.module.scss";

export interface IWorkshopItem {
  baslik: string;
  aciklama: string;
  workshopYil: string;
  kapakGorsel: string;
  yatayGorsel: string;
  workshopFotolar: IWorkshopFotolar[];
  id: string;
  status: number;
  createdDate: string;
  updatedDate: string | null;
}

export interface IWorkshopFotolar {
  dosya: string;
  dosyaTip: string;
  sira: number;
  workshopId: string;
  id: string;
  status: number;
  createdDate: string;
  updatedDate: string | null;
}
/* 
const data: IWorkshopItem[] = [
  {
    baslik: "deneme1",
    aciklama:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat null...",
    workshopYil: "2025-01-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme1.5",
    aciklama: "deneme deneme deneme",
    workshopYil: "2025-01-04T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme2",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-12-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb8",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme3",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-11-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb9",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "test123",
    aciklama: "dasdasd",
    workshopYil: "2024-09-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme4",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-08-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme5",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-07-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb8",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme6",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-06-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb9",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
];
*/

const IzmiriBG: React.FC = () => {
  const navigate = useNavigate();
  const { workshoplar: data, isLoading, error } = useData();

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  const sortedItems = [...data].sort((a, b) => {
    const dateA = new Date(a.workshopYil);
    const dateB = new Date(b.workshopYil);
    return dateB.getTime() - dateA.getTime();
  });

  const groupedByDate = sortedItems.reduce((acc, item) => {
    const date = formatDate(item.workshopYil).toUpperCase();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {} as Record<string, typeof sortedItems>);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>İZMİR’İ BİRLİKTE GÜZELLEŞTİRELİM!</h1>

      <div className={styles.workshopsContainer}>
        {Object.entries(groupedByDate).map(([date, items]) => (
          <div key={date} className={styles.dateGroup}>
            <div className={`${styles.tarih} ${styles.fixed}`}>{date}</div>
            {items.map((item) => (
              <div className={styles.workshopWrapper} key={item.id}>
                <div className={styles.item}>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.kapakGorsel}
                      alt={item.baslik}
                      style={{objectFit:item.id === "34bf5ec5-4fd4-46f9-3d4f-08dda28a49dc" ? "contain":"cover"}}
                      onClick={() =>
                        navigate(`/birlikteGuzellestirelimDetay/${item.baslik}/${item.id}`, {state:{_id:item.id}})
                      }
                    />
                  </div>
                  <div className={styles.content}>
                    <h2
                      className={styles.workshopTitle}
                      onClick={() =>
                          navigate(`/birlikteGuzellestirelimDetay/${item.baslik}/${item.id}`, {state:{_id:item.id}})
                      }
                    >
                      {item.baslik}
                    </h2>
                    <p className={styles.workshopYil}>
                      {new Date(item.workshopYil).toLocaleDateString("tr-TR", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                    <div className={styles.aciklama}>
                      {richTextRenderer(item.aciklama)}
                    </div>
                    <Button
                      className={styles.button}
                      style={{ marginTop: "auto" }}
                      onClick={() =>
                        navigate(`/birlikteGuzellestirelimDetay/${item.baslik}/${item.id}`)
                      }
                    >
                      Daha Fazlasını Gör
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default IzmiriBG;
